import { useFormBuilderStore } from '../store'
import { ComponentsRenderer } from './ComponentsRenderer'
import { DropZone } from './DropZone'

export function Canvas() {
	const formComponents = useFormBuilderStore((state) => state.formComponents)
	const visibleComponents = formComponents.filter((component) => component.action !== 'delete')

	return (
		<div className='h-full bg-neutral-0 p-6'>
			{visibleComponents.length === 0 ? (
				<div className='flex flex-col gap-4 h-full'>
					<DropZone
						id='root-0'
						containerId={undefined}
						index={0}
						className='h-full border-2 border-dashed border-primary-300 rounded-md'
					/>
				</div>
			) : (
				<ComponentsRenderer components={formComponents} />
			)}
		</div>
	)
}
